import { Injectable } from '@angular/core';
import { PageService } from './page.service';
import { ContactoPage } from '../models/contacto-page';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ContactoService extends PageService<ContactoPage> {

  constructor(http: HttpClient) {
    super(http);
  }
}
